var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teacher"},[_c('list-template',{ref:"myTable",attrs:{"total":_vm.total,"table-data":_vm.tableData,"table-config":_vm.tableConfig,"search-config":_vm.searchConfig,"current-page":_vm.page},on:{"onSearch":_vm.onSearch,"onReset":_vm.onReset,"onChangePage":_vm.changeCurrentPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }